//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    productName: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: false,
    },
    isEmit: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isPopular: {
      type: Boolean,
      default: false,
      required: false,
    },
    isDocument: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: "Get Started",
    },
  },
  methods: {
    clickLink() {
      if (this.isEmit) {
        this.$emit("click");
      } else {
        window.location = this.link;
      }
    },
  },
};
